<div class="footer bg-black text-white text-center p-1 fixed bottom-0 w-full z-1000 text-[16px]">

  <div class="text-lg"> {{lang.Version}} :3.2.53 &nbsp; &nbsp;© {{currentYear}} :
    <a class="text-reset fw-bold" href="https://www.groupbenefitz.ca/" target="-blank">
      {{lang.The_GroupBenefitz_Platform_Inc}}</a>
  </div>
</div>